<template>
    <v-card elevation="0" class="annotation mb-0">
        <v-card-title class="text-subtitle-1 mb-2" style="border-bottom: 1px solid #efefef">
            <v-img max-width="25px" height="25px" class="rounded-circle mr-1" v-if="annotation.user_created.avatar"
                :src="`https://api.mylegis.com.br/assets/${annotation.user_created.avatar.id}`" />
            <v-img max-width="25px" height="25px" class="rounded-circle mr-1" v-if="!annotation.user_created.avatar"
                contain src="../assets/icon-person.svg" />
            <!-- <router-link :to="`/painel/u/${slugName(annotation.user_created)}`" class="mr-2"> -->
            {{
                annotation.user_created.first_name
                }}

                {{ annotation.user_created.last_name !== null ? annotation.user_created.last_name : "" }}
            <!-- </router-link> -->
            em
            <router-link class="ml-2" style="color: #000" :to="'/painel/lei/' +
                annotation.id_lei.id_lei +
                '/' +
                sanitizeTitle(annotation.id_lei.numero_lei)
                ">
                {{ annotation.id_lei.numero_lei }}
            </router-link>
        </v-card-title>
        <v-card-text class="annotationText">
            <p class="reg mx-0 "> {{ annotation.id_reg.conteudo }} </p>

            <p class="anno" v-html="annotation.texto"></p>
        </v-card-text>
        <v-card-actions class="d-flex flex-column" style="border-bottom: 1px solid #efefef">
            <div class="d-flex justify-end mb-0 w-100">
                <v-btn :disabled="user.plano === `plano-free`" text
                    @click="importPost = { ...annotation }; showNewAnnotation = true">
                    <v-icon small>mdi-import</v-icon> Importar post</v-btn>
            </div>
            <div class="px-4 d-flex align-center  justify-space-between w-100">
                <p class="mb-0">
                    <!-- <v-chip class="mr-1">
                        <v-icon small class="mr-1">mdi-thumb-up</v-icon> 0 Curtir

                    </v-chip>
                    <v-chip @click="showComments = !showComments">
                        <v-icon small class="mr-1">mdi-comment</v-icon> {{ comments.length }} Comentários
                    </v-chip> -->
                </p>
                <p class="mb-0">
                    <span v-if="annotation.status === `group`">
                        <v-icon>mdi-account-group</v-icon>
                        {{ annotation.id_grupo.nome_grupo }}
                    </span>
                    <span v-else>
                        <v-icon small>{{
                            annotation.status === `private`
                                ? `mdi-lock`
                                : `mdi-earth`
                            }}</v-icon>
                        {{ annotation.status | filterStatus }}
                    </span>

                    <v-icon small class="ml-3">mdi-clock-outline</v-icon>
                    {{ annotation.date_updated === null ? "Criado em" : "Atualizado em" }}
                    {{ annotation.date_updated === null ? annotation.date_created : annotation.date_updated | brdatetime
                    }}
                </p>

            </div>
            <v-list style="background-color:#efefef; border-radius:5px;" v-if="showComments" width="97.5%" class="mt-2  px-3">
                <h5 class="px-0"><v-icon small color="#F15A24">mdi-comment</v-icon> Comentários</h5>
                <v-list-item class="px-0">
                    <v-textarea placeholder="Escreva aqui sua mensagem" rows="1" auto-grow counter v-model="comment"
                        append-icon="mdi-send" color="#F15A24" @click:append="postComment"
                        variant="underlined"></v-textarea>
                </v-list-item>
                <v-list-item v-if="comments.length === 0" class="px-0">
                    <p class="text-center">
                        Seja o primeiro a comentar neste post, digite sua mensagem no campo acima e pressione o botão!
                    </p>
                </v-list-item>
                <v-list-item v-for="(item, i) in comments" :key="i" :value="item" color="primary" rounded="xl"
                    class="px-0">
                    <v-list-item-avatar>
                        <v-avatar color="grey"><v-img contain
                                :src="`https://api.mylegis.com.br/assets/${item.user_created.avatar}`"></v-img></v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.user_created.first_name"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.message"></v-list-item-subtitle>

                    </v-list-item-content>
                    <v-list-item-action v-if="item.user_created.id == user.id">
                        <v-btn  color="grey darken-1"  icon 
                           @click="deleteComment(item.id)"><v-icon>mdi-delete</v-icon></v-btn>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-card-actions>
    </v-card>
</template>
<style scoped>
h5 { 
    color:#F15A24 !important;
}

.annotation {
  border: 1px solid rgb(200 200 200) !important;
  margin: 8px 0px;
  border-radius: 10px;
}

.annotationText div {
  width: 100%;
}

.secondRow h3 {
  margin: 30px 0px 0px 15px;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
  max-width: 100% !important;
}
.reg {
  background-color:#efefef;
  border-radius: 10px;
  padding: 15px;
}
.annotation ::v-deep  a { 
  color:black !important;
  text-decoration:underline;
  padding:0
}

a:hover, .annotation ::v-deep  a:hover { 
  text-decoration:underline;
  color:#F15A24 !important;

}
</style>
<script>
export default {
  name: "HomeFeed",
  props: ["annotation"],
  data() { 
    return { 
        comment: "",
        comments: [],
        showComments: false
    }
  },
  computed: {
    groups() {
      return this.$store.state.user.grupos
    },
    user() {
      return this.$store.state.user;
    }
},
mounted() { 
    // this.reloadComments()
},
  methods: { 
    async reloadComments() {
        try {
            // window.console.log("vai")
            let fields = "id,message,user_created.id,user_created.first_name,user_created.avatar"
            let {data} = await this.$http(`/items/comentarios?sort=-date_created&fields=${fields}&filter[status][_eq]=published&filter[annotation][_eq]=${this.annotation.id}`);
            // window.console.log(data)
            this.comments = data.data
        } catch (e) { window.console.log(e) }
    },
    async postComment() {
        try {
            if (this.comment.length > 300) return
            // console.log(route.params)
            // const filter = { status:"published", asset: photo.value.id};
            const {data} = await this.$http.post("/items/comentarios",{
                    annotation: this.annotation.id,
                    status: "published",
                    message: this.comment
                });

            // selective.value = items[0]
            // window.console.log(data)

            if (data.data.id){
                this.comment=""
                this.reloadComments()
            }
        } 
        catch (e) {
            window.console.log(e)
        }
    },
    async deleteComment(id) { 
        const data = await this.$http.patch("/items/comentarios/"+id, {status: "draft"})
        window.console.log(data)
        this.reloadComments()
    },
    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
    slugName(user) { 
        return user.id +"/"+ this.sanitizeTitle(user.first_name)
    }
  }
}
</script>